import {Component, OnInit} from '@angular/core';
import { UserblockService } from "./userblock.service";
import { RmsService } from '../../../../../projects/jv-common/src/public_api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {


  username: any;
  avatar: string = 'assets/img/user/default.jpg';

  constructor(
    public router: Router,
    public userblockService: UserblockService,
    private rms: RmsService) {
  }

  ngOnInit() {

    this.rms.request<string, Array<any>>({ service: 'Coffee.GetUser', data: '' }).subscribe(response => {

      if (response.succeed) {
        this.username = response.data[0][2];
        this.avatar = window.location.protocol + '//api.ahacafe.vn/user/' + response.data[0][0] + '/avatar.jpg';
      }
    });
  }

  userBlockIsVisible() {
    return this.userblockService.getVisibility();
  }
}
